import { Link } from "react-router-dom";
import { buildFounderSectionHubPath } from "../../founder/founderNavigation";

export function FounderBrandMark({
  asLink = true,
  subIdentity,
  subIdentityInline = false,
}: {
  asLink?: boolean;
  subIdentity?: string;
  subIdentityInline?: boolean;
}) {
  const subClass = subIdentity
    ? subIdentityInline
      ? " oac-founder-brand--with-sub-inline"
      : " oac-founder-brand--with-sub"
    : "";

  const wordmark = (
    <>
      <span className="oac-founder-brand__name">OpenAppCart</span>
      {subIdentity ? (
        <span className="oac-founder-brand__sub">{subIdentity}</span>
      ) : null}
    </>
  );

  if (!asLink) {
    return (
      <div className={`oac-founder-brand oac-founder-brand--static${subClass}`}>
        {wordmark}
      </div>
    );
  }

  return (
    <Link
      aria-label="OpenAppCart Founder Control Centre home"
      className={`oac-founder-brand${subClass}`}
      to={buildFounderSectionHubPath("overview")}
    >
      {wordmark}
    </Link>
  );
}
